import { Apis, Labels } from '../../app.constants';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import {
  alertAtom,
  callersListAtom,
  channelListAtom,
  dialerAgentListAtom,
  interveneFilterAtom,
  messageListAtom,
  supplierListAtom,
  userDetailAtom,
  userJourneyAtom,
  userListAtom,
  userSupplierListAtom,
  userInformationAtom,
} from '../../_states';
import { chatCountsAtom } from '../../_states/index.js';

import APIService from '../../APIService';
import SweetAlert from '../../../components/Shared/Notification';
import { USATimeZone } from '../../../utils/helper';
const InterveneActions = () => {
  const loggedInUser = useRecoilValue(userInformationAtom);
  const [supplierList, setSupplierList] = useRecoilState(supplierListAtom);
  const setIsLoading = useSetRecoilState(alertAtom);
  const [userList, setUserListAtom] = useRecoilState(userListAtom);
  const setUserDetail = useSetRecoilState(userDetailAtom);
  const setUserJourney = useSetRecoilState(userJourneyAtom);
  const setDialerAgent = useSetRecoilState(dialerAgentListAtom);
  const setcallerIds = useSetRecoilState(callersListAtom);
  const [messageList, setMessageList] = useRecoilState(messageListAtom);
  const [channelList, setChannelList] = useRecoilState(channelListAtom);
  const interveneFilter = useRecoilValue(interveneFilterAtom);
  const setUserSupplierList = useSetRecoilState(userSupplierListAtom);
  const setChatCountsAtom = useSetRecoilState(chatCountsAtom);

  const userTypesList = [
    { label: 'Intervene', value: 'intervene' },
    { label: '15 min', value: '15-min' },
    { label: '24 Hrs', value: 'active' },
    { label: 'History', value: 'history' },
  ];

  const getSupplierList = async () => {
    if (supplierList?.length <= 0) {
      try {
        let res = await APIService.get(Apis.getSupplierList);
        if (res.status == 200) {
          let list = res?.data?.map((item) => {
            return { label: item[1], value: item[0] };
          });
          setSupplierList(list);
        }
      } catch (error) {
        return error;
      }
    }
  };

  const getUserDetailByNumber = async (data) => {
    try {
      let res = await APIService.get(`${Apis.getUserDetails}?phone_number=${data?.phone_number}`);
      if (res?.status == 200) {
        if (Object.keys(res?.data).length === 0) setUserDetail({ ...data });
        else setUserDetail({ ...data, ...res?.data });
      }
    } catch (err) {
      return err;
    }
  };

  const refreshChatCounts = async (botNumber) => {
    if (!botNumber) return;
    try {
      const res = await APIService.get(`${Apis.getChatUsersCounts}?bot_number=${botNumber}`);
      if (res?.status === 200) {
        const totals = res?.data?.user_counts ?? {};
        // Import and use setChatCounts via the shared atom
        setChatCountsAtom({
          intervene: Number(totals?.intervene) || 0,
          min_15: Number(totals?.min_15) || 0,
          hrs_24: Number(totals?.hrs_24) || 0,
          history: Number(totals?.history) || 0,
          total: Number(totals?.total) || 0,
        });
      }
      return res;
    } catch (error) {
      return error;
    }
  };

  // const getChatUsersCounts = async (botNumber) => {
  //   if (!botNumber) return null;
  //   try {
  //     const res = await APIService.get(`${Apis.getChatUsersCounts}?bot_number=${botNumber}`);
  //     return res;
  //   } catch (error) {
  //     console.error('getChatUsersCounts error:', error);
  //     throw error;
  //   }
  // };

  const getUserJourney = async (data) => {
    try {
      let url = `${Apis.getUserJuorney}?phone_number=${data?.phone_number}`;
      if (data?.bot_number) url += `&bot_number=${data?.bot_number}`;
      let res = await APIService.get(url);
      if (res.status == 200) setUserJourney(res?.data ?? []);
    } catch (err) {
      return err;
    }
  };

  const getCallerIds = async () => {
    try {
      let res = await APIService.get(Apis.getDialerCallerIds);
      if (res.status == 200) setcallerIds(res?.data);
    } catch (error) {
      return error;
    }
  };

  const getDialerAgents = async () => {
    try {
      let res = await APIService.get(Apis.getDialerAgents);
      if (res.status == 200) setDialerAgent(res?.data);
    } catch (error) {
      return error;
    }
  };

  const postDialerCall = async (data) => {
    try {
      let res = await APIService.post(Apis.postDialerCall, data);
      if (res?.status === 200) {
        SweetAlert(res?.data?.data?.message, 'success');
      }
    } catch (error) {
      return error;
    }
  };

  const getContactList = async (data) => {
    try {
      let res = await APIService.get(
        `${Apis.getHistoryUser}?next_page=${data?.page}&type_of_entity=${data?.typeOfEntity}`
      );
      if (res.status == 200) return res?.data;
    } catch (error) {
      return error;
    }
  };

  const getSupplierByNumber = async (number) => {
    let res = await APIService.get(`${Apis.getSupplierByNumber}?phone_number=${number}`);
    if (res.status == 200) {
      setUserSupplierList(res?.data);
      return res?.data;
    }
  };

  const getSupplierDetails = async (supplierId) => {
    let res = await APIService.get(`${Apis.getsupplierDetails}?supplier_id=${supplierId}`);
    if (res.status == 200) {
      return res.data;
    } else {
      SweetAlert(Labels.Error, 'error');
    }
  };

  const postSupplierData = async (data) => {
    let res = await APIService.post(Apis.postSupplierDetails, { data: data });
    return res;
  };

  const getSocietyImages = async (data) => {
    let res = await APIService.get(
      `${Apis.getPostSocietyImages}?supplier_id=${data.supplier_id}&supplier_type_code=${data.supplier_type}`
    );
    if (res.status === 200) {
      return res?.data;
    } else {
      SweetAlert(Labels.Error, 'error');
    }
  };

  const deleteSocietyImages = async (data) => {
    let res = await APIService.remove(`${Apis.getPostSocietyImages}?pk=${data.id}`);
    if (res.status === 200) {
      SweetAlert(Labels.Delete_Success, 'success');
      return res;
    } else {
      SweetAlert(Labels.Error, 'error');
    }
  };

  const postSoceityImages = async (data) => {
    let res = await APIService.post(`${Apis.getPostSocietyImages}?supplier_type_code=RS`, data);
    if (res?.status === 200) SweetAlert(Labels.Upload_Success, 'success');
    else SweetAlert(Labels.Error, 'error');
  };

  // V1  01/2024
  const getUserListV1 = async (filters) => {
    if (filters?.botNumber) {
      let res = await APIService.get(
        `${Apis.getActiveUser}?bot_number=${filters?.botNumber}&user_status=${filters?.userType}&next_page=${filters?.page}&search=${filters?.search}&campaign_id=${filters?.campaignId || ''}`
      );
      if (res.status === 200) {
        if (filters?.resetUserList) {
          setUserListAtom({
            users: [...res?.data?.list],
            total_count: res?.data?.count,
          });
        } else {
          setUserListAtom({
            users: [...userList.users, ...res?.data?.list],
            total_count: res?.data?.count,
          });
        }
      }
    } else {
      setUserListAtom({ users: [], total_count: 0 });
      setUserDetail({});
      SweetAlert('Please Select Bot', 'error');
    }
  };

  const getUserMessages = async (filters) => {
    if (!interveneFilter?.botNumber) {
      SweetAlert('Please Select Bot Number', 'error');
      setIsLoading(false);
      return 0;
    }
    let url = `/v0/ui/intervene/get-master-conversion/?phone_number=${filters?.phone_number}&bot_number=${interveneFilter?.botNumber}&next_page=${filters?.page}`;
    if (filters?.chat_type) url += `&chat_type=${filters?.chat_type}`;
    if (filters?.intervened_by) url += `&intervened_by=${filters?.intervened_by}`;
    let res = await APIService.get(url);
    // let res = await APIService.get(
    //   `/v0/ui/intervene/get-master-conversion/?phone_number=${filters?.phone_number}&bot_number=${interveneFilter?.botNumber}&next_page=${filters?.page}&${queryParams.toString() ? `&${queryParams.toString()}` : ''}`
    // );
    if (res.status == 200) {
      let sortedData = res?.data?.data?.reverse();
      if (filters?.page === 1)
        setMessageList((prev) => ({
          ...prev,
          messages: sortedData,
          total_count: res?.data?.total_count,
        }));
      // setMessageList({ messages: sortedData, total_count: res?.data?.total_count });
      else
        setMessageList((prev) => ({
          ...prev,
          messages: [...sortedData, ...messageList?.messages],
          total_count: res?.data?.total_count,
        }));

      // setMessageList({
      //   messages: [...sortedData, ...messageList?.messages],
      //   total_count: res?.data?.total_count,
      // });
    }
    setIsLoading(false);
  };

  const sendMessageV1 = async (formData) => {
    if (!interveneFilter?.botNumber) {
      SweetAlert('Please Select Bot Number', 'error');
      return 0;
    }
    formData.append('bot_number', interveneFilter?.botNumber);
    let res = await APIService.post(`v0/ui/intervene/send-message/`, formData, {
      'Content-Type': 'multipart/form-data',
    });
    if (res?.data?.status) {
      console.log('Message sent successfully');
      // let newMessage = {
      //   msg_id: USATimeZone(),
      //   created_at: USATimeZone(),
      //   timestamp: Math.floor(Date.now() / 1000),
      //   origin: 'OUTBOUND',
      //   status: { type: 'new message sent', timestamp: USATimeZone() },
      // };
      // let file = formData?.get('file');
      // let content = {};
      // switch (formData?.get('type')) {
      //   case 'image':
      //     content = { type: 'image', previewUrl: URL?.createObjectURL(file) };
      //     break;

      //   case 'audio':
      //     content = { type: 'audio', url: URL?.createObjectURL(file) };
      //     break;

      //   case 'video':
      //     content = { type: 'video', url: URL?.createObjectURL(file) };
      //     break;

      //   case 'file':
      //     content = { type: 'file', url: URL?.createObjectURL(file) };
      //     break;

      //   default:
      //     content = { type: 'text', text: formData?.get('text') };
      //     break;
      // }
      // newMessage = { ...newMessage, content };

      // setMessageList({
      //   ...messageList,
      //   messages: [...messageList.messages, newMessage],
      //   total_count: messageList.total_count + 1,
      // });
    } else SweetAlert('Error', 'error');
  };

  // const getAllChannels = async (organisationId = '') => {
  //   setChannelList([]);
  //   let comapnyId = '';
  //   if (!organisationId) {
  //     comapnyId = loggedInUser?.profile?.organisation?.organisation_id;
  //   } else {
  //     comapnyId = organisationId;
  //   }
  //   // if (channelList.length <= 0) {
  //   // let res1 = await APIService.get(`${Apis.getAllChannels}?company_id=${comapnyId}`);
  //   // console.log(res1);
  //   let res = await APIService.get(`${Apis.whatsappBusinessAccounts}?company_id=${comapnyId}`);
  //   if (res?.status === 200) {
  //     const updatedData = res?.data?.map((obj) => {
  //       const { wa_phone_number, ...rest } = obj; // Destructure to extract oldKey and rest of the object
  //       return { channel_number: wa_phone_number, wa_phone_number, ...rest }; // Return a new object with newKey and other properties
  //     });
  //     setChannelList(updatedData); //setChannelList(res?.data?.data);
  //   }
  //   // }
  // };
  const getAllChannels = async (organisationId = '') => {
    setChannelList([]);
    let comapnyId = '';
    if (!organisationId) {
      comapnyId = loggedInUser?.profile?.organisation?.organisation_id;
    } else {
      comapnyId = organisationId;
    }
    // if (channelList.length <= 0) {
    // let res1 = await APIService.get(`${Apis.getAllChannels}?company_id=${comapnyId}`);
    // console.log(res1);
    try {
      const res = await APIService.get(`${Apis.whatsappBusinessAccounts}?company_id=${comapnyId}`);
      if (res?.status === 200) {
        // Normalize response to an array regardless of shape
        let source = [];
        if (Array.isArray(res?.data)) source = res.data;
        else if (Array.isArray(res?.data?.data)) source = res.data.data;
        else if (res?.data && typeof res.data === 'object') source = Object.values(res.data);

        const updatedData = (source || []).map((obj) => {
          const { wa_phone_number, ...rest } = obj || {};
          return { channel_number: wa_phone_number, wa_phone_number, ...rest };
        });

        setChannelList(updatedData);
      }
    } catch (err) {
      return err;
    }
    // }
  };
  // CHAT summary
  const getFlowListByBotNumber = async (botNumber) => {
    let res = await APIService.get(`${Apis.getFlowListByBotNumber}?bot_number=${botNumber}`);
    if (res?.status === 200) return res?.data;
  };
  const getUserChatSummary = async (filtersObj) => {
    let res = await APIService.get(
      `${Apis.getUserChatSummary}?bot_number=${filtersObj?.bot_number}&flow_id=${filtersObj?.flowId}`
    );
    if (res?.status === 200) return res;
  };
  const startEndSession = async (payload) => {
    const res = await APIService.post(`${Apis.startEndSession}`, payload);
    return res;
  };

  return {
    userTypesList,
    getSupplierList,
    getUserDetailByNumber,
    getUserJourney,
    getCallerIds,
    // getChatUsersCounts,
    getDialerAgents,
    postDialerCall,
    getContactList,
    getSupplierByNumber,
    getSupplierDetails,
    postSupplierData,
    getSocietyImages,
    postSoceityImages,
    deleteSocietyImages,
    // V1
    getUserListV1,
    getUserMessages,
    sendMessageV1,
    getAllChannels,
    // Chat Summary
    getFlowListByBotNumber,
    getUserChatSummary,
    startEndSession,
    refreshChatCounts,
  };
};

export { InterveneActions };
